import {Component} from '@angular/core';
import {UserService} from '../../../services/user.service';

import {BreadcrumbComponent} from "../../../components/common/breadcrumb/breadcrumb.component";
import {UserFormComponent} from "./user-form/user-form.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {RouterLink} from "@angular/router";

@Component({
    selector: 'app-users-create',
    imports: [
    BreadcrumbComponent,
    UserFormComponent,
    FaIconComponent,
    RouterLink
],
    templateUrl: './users-create.component.html',
    styleUrls: ['./users-create.component.css']
})
export class UsersCreateComponent {

  created = false;

  constructor(private userRequest: UserService) {
  }

  createUser(user): void {
    // Delete the temporary field 'product'
    delete user.products.product;
    for (const p in user.products) {
      if (user.products[p].formdate) {
        const d = user.products[p].formdate;
        user.products[p].formdate = `${d.day}-${d.month}-${d.year}`;
      }
    }
    this.userRequest.createRequest(user).subscribe(() => {
      this.created = true;
    });
  }
}
